// extracted by mini-css-extract-plugin
var _1 = "FhtCiC1vdea8mzHFzKfO";
export { _1 as "page" }
